import styled from "styled-components";

export const Wrapper = styled.div`
  overflow: hidden;
  flex-direction: column;
  align-items: center;
  display: flex;
`;
